import React from 'react';
import { useOidcAuthentication } from './use-authentication';
import { useAutoLogout } from './use-autologout';

export type OidcAutoLogoutProps = {
    idleTimeInMinutes: number;
    redirectUri: string;
    debounce?: number;
    children?: React.ReactNode;
};

export const OidcAutoLogout: React.FC<OidcAutoLogoutProps> = ({
    redirectUri,
    idleTimeInMinutes,
    debounce,
    children,
}) => {
    const auth = useOidcAuthentication();
    const logout = () => auth.logout({ post_logout_redirect_uri: redirectUri });
    useAutoLogout(auth, idleTimeInMinutes, redirectUri, debounce, logout);

    return <>{children}</>;
};
